
import React, { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import { toast } from "react-toastify";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleError } from "../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../api/AxiosApiCall";
import ApiServices from "../../api/ApiServices";
import locationData from "../../components/utils/locationData.json";

const EditDeliveryPrice = () => {
    const navigate = useNavigate();
    const locationHook = useLocation();
    const { deliveryPrice } = locationHook.state || {};

    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [amount, setAmount] = useState("");
    const [location, setLocation] = useState("");
    const [lcda, setLcda] = useState("");
    const [id, setId] = useState("");
    const [loading, setLoading] = useState(false);

    // Populate form when editing
    useEffect(() => {
        if (deliveryPrice) {
            // console.log("delivery", deliveryPrice);
            setState(deliveryPrice.state);
            setCity(deliveryPrice.city);
            setAmount(deliveryPrice.amount);
            setLocation(deliveryPrice.location);
            setLcda(deliveryPrice.lcda);
            setId(deliveryPrice.id);
        }
    }, [deliveryPrice]);

    // Find selected state
    const selectedStateData = locationData.find((item) => item.state === state);

    // Find selected city
    const selectedCityData = selectedStateData?.cities.find(
        (item) => item.name === city
    );

    // Build city and location lists
    const cities = selectedStateData
        ? selectedStateData.cities.map((c) => c.name)
        : [];
    const locations = selectedCityData ? selectedCityData.locations : [];

    const validateForm = () => {
        if (!amount || !state || !city || !location) {
            toast.error("All fields are required.");
            return false;
        }
        return true;
    };

    const axios = AxiosApiCall();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);

        const formData = {
            amount,
            state,
            city,
            location,
            lcda: location,
            lga: city,
            id
        };
        // console.log("form data", formData);
        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) throw new Error("No access token found.");



            const response = await axios.post(
                ApiServices.updateDeliveryLocprice,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            const { status, message } = response.data;
            if (status === "200" || status === 200) {
                navigate("/admin/delivery/location");
                toast.success(message, { toastId: "location-price-updated-success" });
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    return (
        <MainLayouts>
            <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                <section className="body-font">
                    <div className="container px-5 pb-2 mx-auto ">
                        <section
                            className="w-full pr-[3%] pt-3 my-3"
                            style={{ backgroundColor: "#F7F7F7" }}
                        >
                            <div className="flex justify-between items-center bg-gray-200 py-2 px-4 rounded-lg mb-3">
                                <nav>
                                    <ol className="list-none p-0 inline-flex">
                                        <li className="flex items-center">
                                            <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                                Location Delivery
                                            </p>
                                            <ChevronRightIcon />
                                        </li>
                                        <li className="flex items-center">
                                            <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                                Price
                                            </p>
                                            <ChevronRightIcon />
                                        </li>
                                        <li className="flex items-center">
                                            <p className="text-orange1">Update</p>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </section>
                        <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                            <form onSubmit={handleSubmit}>
                                <div className="flex w-full mb-3 gap-4">
                                    <input type="hidden" value={id} />
                                    <div className="w-1/2">
                                        <label
                                            htmlFor="state"
                                            className="block mb-2 text-sm font-medium text-gray-900"
                                        >
                                            State
                                        </label>
                                        <select
                                            name="state"
                                            id="state"
                                            value={state}
                                            onChange={(e) => {
                                                setState(e.target.value);
                                                setCity("");
                                            }}
                                            className="bg-gray-50 border border-dGrey1 text-sm rounded-lg block w-full p-2.5"
                                        >
                                            <option value="">Select state</option>
                                            {locationData.map((item) => (
                                                <option key={item.state} value={item.state}>
                                                    {item.state}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="w-1/2">
                                        <label
                                            htmlFor="city"
                                            className="block mb-2 text-sm font-medium text-gray-900"
                                        >
                                            City
                                        </label>
                                        <select
                                            name="city"
                                            id="city"
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                            className="bg-gray-50 border border-dGrey1 text-sm rounded-lg block w-full p-2.5"
                                            disabled={!state}
                                        >
                                            <option value="">Select city</option>
                                            {cities.map((cityName) => (
                                                <option key={cityName} value={cityName}>
                                                    {cityName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="flex w-full mb-3 gap-4">
                                    <div className="w-1/2">
                                        <label
                                            htmlFor="location"
                                            className="block mb-2 text-sm font-medium text-gray-900"
                                        >
                                            Location
                                        </label>
                                        <select
                                            name="location"
                                            id="location"
                                            value={location}
                                            onChange={(e) => {
                                                setLocation(e.target.value);
                                                setLcda(e.target.value);
                                            }}
                                            className="bg-gray-50 border border-dGrey1 text-sm rounded-lg block w-full p-2.5"
                                            disabled={!city}
                                        >
                                            <option value="">Select Location</option>
                                            {locations.map((loc) => (
                                                <option key={loc} value={loc}>
                                                    {loc}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="w-1/2">
                                        <label
                                            htmlFor="amount"
                                            className="block mb-2 text-sm font-medium text-gray-900"
                                        >
                                            Amount
                                        </label>
                                        <input
                                            type="number"
                                            name="amount"
                                            id="amount"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            className="bg-gray-50 border border-dGrey1 text-sm rounded-lg block w-full p-2.5"
                                            placeholder="Enter amount"
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">
                                    <Link
                                        to="/admin/delivery/location"
                                        className="text-dGrey3 bg-black2 py-4 px-6 rounded-lg text-sm text-center"
                                    >
                                        <span className="flex items-center">
                                            <List className="mr-2" />
                                            Back To List
                                        </span>
                                    </Link>

                                    <button
                                        type="submit"
                                        className={`text-dGrey3 bg-darkGreen3 py-2 px-6 rounded font-medium ${loading ? "btn-loading" : "btn-primary"
                                            }`}
                                        disabled={loading || !amount || !location || !state || !city}
                                    >
                                        {loading ? "Loading..." : "Update Delivery Price"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </MainLayouts>
    );
};

export default EditDeliveryPrice;
